<template>
  <div class="tw:flex tw:flex-col tw:w-full tw:min-h-screen-minus-header-and-footer">
    <div class="tw:w-full tw:bg-white">
      <div class="tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mx-auto tw:px-4 tw:py-8">
        <h1 class="tw:font-bold tw:text-2xl tw:flex tw:items-center tw:gap-2">
          {{ $t('rate_insights') }}
          <UiTooltip
            theme="customdarkwithpadding"
            tooltip-position="top"
            :label="$t('rate_insights_tooltip')"
            class="tw:cursor-pointer"
          >
            <InformationOutline class="tw:fill-none tw:stroke-gray-800 tw:h-[16px] tw:w-[16px]" />
          </UiTooltip>
        </h1>
        <p class="tw:text-gray-700 tw:mt-1">{{ $t('published_rates_shown') }}</p>
      </div>
    </div>

    <div class="tw:md:max-w-screen-lg tw:lg:max-w-screen-xl tw:mx-auto tw:w-full tw:px-4 tw:py-8">
      <div class="tw:flex tw:flex-col tw:md:flex-row tw:gap-8 tw:md:items-start">
        <div class="tw:flex-1 tw:flex tw:flex-col tw:py-4">
          <h2 class="tw:font-bold tw:text-xl tw:mb-2">{{ $t('ri_benefit_header') }}</h2>
          <p class="tw:text-gray-700 tw:mb-8">{{ $t('ri_benefit_subtext') }}</p>

          <div class="tw:flex tw:flex-col tw:gap-4">
            <div
              v-for="benefit in benefits"
              :key="benefit.id"
              class="tw:flex tw:items-start tw:gap-4 tw:bg-white tw:rounded-xl tw:p-4 tw:shadow-sm"
            >
              <img :src="benefit.icon" :alt="$t(benefit.titleKey)" class="tw:w-10 tw:h-10 tw:shrink-0" />
              <div>
                <p class="tw:font-bold tw:text-sm">{{ $t(benefit.titleKey) }}</p>
                <p class="tw:text-gray-700 tw:text-sm tw:mt-1">{{ $t(benefit.textKey) }}</p>
              </div>
            </div>
          </div>
        </div>

        <div class="tw:flex-1">
          <RIOnboarding />
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import RIOnboarding from '@/components/rateInsights/RIOnboarding.vue'
import InformationOutline from '@/components/icons/InformationOutline.svg?component'
import UiTooltip from '@/components/dashboard/ui/UiTooltip.vue'

import Benefit1Icon from '@/assets/img/rate-insights/competitors-benefit1.svg'
import Benefit2Icon from '@/assets/img/rate-insights/competitors-benefit2.svg'
import Benefit3Icon from '@/assets/img/rate-insights/competitors-benefit3.svg'

/** Rate Insights benefit card */
interface Benefit {
  id: number
  titleKey: string
  textKey: string
  icon: string
}

/** Benefits displayed in onboarding */
const benefits: Benefit[] = [
  { id: 1, titleKey: 'ri_benefit1_header', textKey: 'ri_benefit1_subtext', icon: Benefit1Icon },
  { id: 2, titleKey: 'ri_benefit2_header', textKey: 'ri_benefit2_subtext', icon: Benefit2Icon },
  { id: 3, titleKey: 'ri_benefit3_header', textKey: 'ri_benefit3_subtext', icon: Benefit3Icon },
]
</script>
